<script>
    import SavePage from "$components/save/SavePage.svelte";
</script>

<SavePage />
